import {EmailNotificationsFrequencyType} from '../../../../service/notifications-settings/notifications-settings-type';

export const emailNotificationsFrequencyList: [EmailNotificationsFrequencyType, EmailNotificationsFrequencyType] = [
    1, 24,
];
